type InsuranceWithClinicScope = {
  agency_clinic_id?: string | null;
};

/**
 * Returns agency insurances valid for a selected clinic.
 * - If no clinic is selected, return all records.
 * - Include clinic-scoped records for the selected clinic.
 * - Optionally include agency-wide records with no clinic scope.
 */
export function filterAgencyInsurancesByClinic<
  T extends InsuranceWithClinicScope,
>(
  agencyInsurances: T[],
  agencyClinicId: string | null | undefined,
  includeAgencyWide = true
): T[] {
  if (!agencyClinicId) {
    return agencyInsurances;
  }

  return agencyInsurances.filter(
    insurance =>
      insurance.agency_clinic_id === agencyClinicId ||
      (includeAgencyWide && !insurance.agency_clinic_id)
  );
}
